import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import Chart from "react-google-charts";
import { Link, useParams, useNavigate } from "react-router-dom";
import { listYearlyReport } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import { ExportToExcel } from "../components/ExportToExcel";

export default function YearlyReportScreen(props) {
  const existedYearlyReport = useSelector((state) => state.existedYearlyReport);
  const { loading, error, existedYearlyReportRecords } = existedYearlyReport;
  const fileName = "YearlyReprot";
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(listYearlyReport());
  }, [dispatch]);

  return (
    <div>
      <h1>Existed Yearly Report</h1>
      <ExportToExcel apiData={existedYearlyReportRecords} fileName={fileName} />
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Record ID</th>
              <th>Description</th>
              <th>Year</th>
              <th>Category</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>other information</th>
            </tr>
          </thead>

          <tbody>
            {existedYearlyReportRecords.map((x) => (
              <tr key={x._id}>
                <td>{x._id}</td>
                <td>{x.description}</td>
                <td>{x.year}</td>
                <td>{x.category}</td>
                <td>{x.amount.toFixed(2)}</td>
                <td>{x.currency}</td>
                <td>{x.fromdate}</td>
                <td>{x.todate}</td>
                <td>{x.otherinfo}</td>
                <td>
                  <button
                    type="button"
                    className="small"
                    onClick={() => {
                      props.history.push(`/x/${x._id}`);
                    }}
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
